import axios from "axios";
import constants from "../config/constants.js";

class Api {
    constructor({ serverUrl }) {
        this._serverUrl = serverUrl
        this._axios = axios.create({
            baseURL: serverUrl,
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            }
        });
    }

    async checkAuth(){
        let data = {}
        await this._axios.get('/internal/checkauth')
            .then(resp => {
                data.res = resp.data
                data.status = resp.status
            })
            .catch(error => {
                if (error.response) {
                    data.err = error.response.data
                    data.status = error.response.status
                }
            })
        return data
    }

    async signIn(step = 1, mobile = null, password = null){
        let data = {}
        await this._axios.post('/internal/signin', {
            Step: step,
            Mobile: mobile,
            Password: password
        }).then(resp => {
                    data.res = resp.data
                    data.status = resp.status
                })
                .catch(error => {
                    if (error.response) {
                        data.err = error.response.data
                        data.status = error.response.status
                    }
                })
        return data
    }

    async signUp(step = 1, mobile = null, password = null, fio = null){
        let data = {}
        await this._axios.post('/internal/signup', {
            Step: step,
            Mobile: mobile,
            Password: password,
            Fio: fio
        }).then(resp => {
                    data.res = resp.data
                    data.status = resp.status
                })
                .catch(error => {
                    if (error.response) {
                        data.err = error.response.data
                        data.status = error.response.status
                    }
                })
        return data
    }

    async getMarks(params) {
        let data = {}
        await this._axios.get('/getmarks', { params })
            .then(resp => {
                data.status = resp.status
                data.data = resp.data
                // console.log(data);
                
            })
            .catch(error => {
                if (error.response) {
                    data.status = error.response.status
                    data.err = error.response.data
                }
            })
        return data
    }

    async getDriverByMarkId(markerId) {
        let data = {}
        await this._axios.get('/markersinfo', { params: { marker_id: markerId } })
            .then(resp => {
                data.status = resp.status
                data.data = resp.data
            })
            .catch(error => {
                if (error.response) {
                    data.status = error.response.status
                    data.err = error.response.data
                }
            })
        return data
    }
}

const API = new Api({
    serverUrl: constants.API_ADRESS
});

export default API;